import React, { useState, useEffect } from 'react';
import Markdown from 'global/components/Markdown';
import NavToTop from 'feature/nav/NavToTop';
import { get } from 'global/lib/lodash';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { GridContainer } from 'global/components/perform-grid';
import { PolicyContent, PolicyIcon, PolicyLogos, PolicyPerformLogo } from './Policy.styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import HomeIcon from '@mui/icons-material/Home';
import Image from 'global/components/image';
import isLoggedIn from 'global/utils/isLoggedIn';
import logo from 'assets/perform_with_ibacos.svg';

import policy from 'global/../../PRIVACY_POLICY.md';
import terms from 'global/../../USER_AGREEMENT.md';
// import faq from 'global/../../README_FAQ.md';

export default function Policy(props) {
  const [markdown, setMarkdown] = useState('');
  const [page, setPage] = useState(policy);
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));

  const { type } = get(props, 'match.params', {});

  useEffect(() => {
    setPage(type === 'terms' ? terms : policy);
  }, [type]);

  useEffect(() => {
    fetch(page)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, [page]);

  return (
    <div>
      <AppBar position="static">
        <Toolbar component={Link} to="/" variant="dense">
          {loggedIn ? (
            <PolicyIcon>
              <HomeIcon />
              Home
            </PolicyIcon>
          ) : (
            <PolicyIcon>
              <HomeIcon />
              Login
            </PolicyIcon>
          )}
        </Toolbar>
      </AppBar>
      <GridContainer>
        <PolicyContent>
          <PolicyLogos>
            <PolicyPerformLogo as={Image} src={logo} alt="" />
          </PolicyLogos>
          <Typography component={Link} to={type === 'terms' ? '/policy' : '/policy/terms'}>
            {type === 'terms' ? 'Privacy Policy' : 'User Agreement'}
          </Typography>
          <NavToTop />
          <Markdown>{markdown}</Markdown>
          <Typography component={Link} to={type === 'terms' ? '/policy' : '/policy/terms'} onClick={window.scroll(0, 0)}>
            {type === 'terms' ? 'Privacy Policy' : 'User Agreement'}
          </Typography>
        </PolicyContent>
      </GridContainer>
    </div>
  );
}
